export const BUY_COIN = 'BUY_COIN' as const;
export const USE_COIN = 'USE_COIN' as const;
export const UPDATE_AUTO = 'UPDATE_AUTO' as const;
